import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose, lifecycle, withProps } from 'recompose';
import moment from 'moment';

import * as styles from '../styles.css';
import { withFetch } from '../../../../app/entities/Entity/containers';
import { Endpoints } from '../../../../app/lib/LeanLinkService';

function TimeReportsNotification({ unreportedDatesCount }) {
  if (unreportedDatesCount <= 0) {
    return null;
  }

  return (
    <div className={classNames('btn-danger', styles.timereportsNotification)}>
      {unreportedDatesCount}
    </div>
  );
}

TimeReportsNotification.defaultProps = {
  unreportedDatesCount: 0,
};

TimeReportsNotification.propTypes = {
  unreportedDatesCount: PropTypes.number,
};

export default compose(
  withProps({
    from: moment().add(-3, 'month').format('YYYY-MM-DD'),
    to: moment().add(-1, 'day').format('YYYY-MM-DD'),
  }),
  withFetch(),
  lifecycle({
    componentWillMount() {
      this.props.fetch({
        url: Endpoints.public.resourceApi.unreportedTimes({
          from: this.props.from,
          to: this.props.to,
        }),
      }).then((data) => {
        const unreportedDatesCount = data.result.id.unreportedDatesCount;
        this.setState({ unreportedDatesCount });
      });
    },
  }),
)(TimeReportsNotification);
